/**
 * Coups de pouce — Attendu 662 « Mesurer un angle ».
 *
 * Une entrée par `generator_key` (cf. gen_662.js). Une entrée peut être un objet
 * `{ pages }` ou une fonction `(question) => ({ pages })` quand les variantes du
 * format demandent des aides différentes (cf. utils/coupDePouce.js).
 *
 * Règle absolue : l'aide porte sur d'AUTRES valeurs que celles que le
 * générateur peut tirer, sinon elle donne la réponse.
 * Emphase : **texte** (rendu en gras, pas de HTML brut). Pas de tiret cadratin.
 */

// -- Figure Ex. 1 : les deux graduations du rapporteur --
// 50 deg : absent de MESURES_EX1 (15, 25, 35, 42, 55, 65, 75, 85, 95, 105, 115,
// 125, 135, 145, 155, 165), donc jamais une bonne reponse. Les DEUX lectures
// sont montrees, la verte retenue et la rouge ecartee : le distracteur 180 - m
// est present dans 100 % des tirages, c'est le piege que la fiche doit desamorcer.
const SVG_RAPPORTEUR = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 238" role="img"
     aria-label="Un rapporteur pose sur un angle. Le cote de l angle part du zero de la graduation verte, la lecture donne 50 degres ; l autre graduation donnerait 130 degres.">
  <path d="M 298 176 A 118 118 0 0 0 62 176" fill="none" stroke="#94A3B8" stroke-width="1.4"/>
  <line x1="62" y1="176" x2="298" y2="176" stroke="#94A3B8" stroke-width="1.4"/>
  <line x1="298.0" y1="176.0" x2="286.0" y2="176.0" stroke="#94A3B8" stroke-width="1.4"/>
  <text x="264.0" y="170.5" text-anchor="middle" font-size="9" fill="#1D9E75">0</text>
  <text x="236.0" y="170.5" text-anchor="middle" font-size="9" fill="#E24B4A">180</text>
  <line x1="296.2" y1="155.5" x2="289.3" y2="156.7" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="290.9" y1="135.6" x2="284.3" y2="138.0" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="282.2" y1="117.0" x2="271.8" y2="123.0" stroke="#94A3B8" stroke-width="1.4"/>
  <text x="252.7" y="137.5" text-anchor="middle" font-size="9" fill="#1D9E75">30</text>
  <text x="228.5" y="151.5" text-anchor="middle" font-size="9" fill="#E24B4A">150</text>
  <line x1="270.4" y1="100.2" x2="265.0" y2="104.7" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="255.8" y1="85.6" x2="251.3" y2="91.0" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="239.0" y1="73.8" x2="233.0" y2="84.2" stroke="#94A3B8" stroke-width="1.4"/>
  <line x1="220.4" y1="65.1" x2="218.0" y2="71.7" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="200.5" y1="59.8" x2="199.3" y2="66.7" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="180.0" y1="58.0" x2="180.0" y2="70.0" stroke="#94A3B8" stroke-width="1.4"/>
  <text x="180.0" y="95.5" text-anchor="middle" font-size="9" fill="#1D9E75">90</text>
  <text x="180.0" y="123.5" text-anchor="middle" font-size="9" fill="#E24B4A">90</text>
  <line x1="159.5" y1="59.8" x2="160.7" y2="66.7" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="139.6" y1="65.1" x2="142.0" y2="71.7" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="121.0" y1="73.8" x2="127.0" y2="84.2" stroke="#94A3B8" stroke-width="1.4"/>
  <text x="138.0" y="106.8" text-anchor="middle" font-size="9" fill="#1D9E75">120</text>
  <text x="152.0" y="131.0" text-anchor="middle" font-size="9" fill="#E24B4A">60</text>
  <line x1="104.2" y1="85.6" x2="108.7" y2="91.0" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="89.6" y1="100.2" x2="95.0" y2="104.7" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="77.8" y1="117.0" x2="88.2" y2="123.0" stroke="#94A3B8" stroke-width="1.4"/>
  <text x="107.3" y="137.5" text-anchor="middle" font-size="9" fill="#1D9E75">150</text>
  <text x="131.5" y="151.5" text-anchor="middle" font-size="9" fill="#E24B4A">30</text>
  <line x1="69.1" y1="135.6" x2="75.7" y2="138.0" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="63.8" y1="155.5" x2="70.7" y2="156.7" stroke="#94A3B8" stroke-width="0.9"/>
  <line x1="62.0" y1="176.0" x2="74.0" y2="176.0" stroke="#94A3B8" stroke-width="1.4"/>
  <text x="96.0" y="170.5" text-anchor="middle" font-size="9" fill="#1D9E75">180</text>
  <text x="124.0" y="170.5" text-anchor="middle" font-size="9" fill="#E24B4A">0</text>
  <line x1="180" y1="176" x2="312" y2="176" stroke="#0f172a" stroke-width="2.4"/>
  <line x1="180" y1="176" x2="264.8" y2="74.9" stroke="#0f172a" stroke-width="2.4"/>
  <path d="M 210 176 A 30 30 0 0 0 199.3 153.0" fill="none" stroke="#F97316" stroke-width="2.2"/>
  <circle cx="180" cy="176" r="3.5" fill="#0f172a"/>
  <text x="234.0" y="115.7" text-anchor="middle" font-size="12" font-weight="700" fill="#1D9E75">50</text>
  <text x="216.0" y="137.1" text-anchor="middle" font-size="12" font-weight="700" fill="#E24B4A">130</text>
  <text x="180" y="208" text-anchor="middle" font-size="11.5" font-weight="700" fill="#1D9E75">le côté part du 0 vert : on lit 50°</text>
  <text x="180" y="226" text-anchor="middle" font-size="11" fill="#E24B4A">l’autre graduation donnerait 130°, c’est le piège</text>
</svg>`.trim();

// -- Figure Ex. 3 : les quatre mesures canoniques --
// L'exercice ne porte que sur nul / droit / plat / plein (aigu et obtus sont
// exclus, c'est la partition avec l'attendu 661). La fiche montre donc ces
// quatre-la, dessines, avec leur mesure.
const SVG_CANONIQUES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 158" role="img"
     aria-label="Les quatre angles canoniques dessines : nul a 0 degre, droit a 90 degres, plat a 180 degres, plein a 360 degres.">
  <line x1="26" y1="95" x2="64" y2="95" stroke="#0f172a" stroke-width="2"/>
  <line x1="26" y1="95" x2="63.6" y2="89.7" stroke="#0f172a" stroke-width="2"/>
  <circle cx="26" cy="95" r="2.6" fill="#0f172a"/>
  <text x="45" y="128" text-anchor="middle" font-size="12.5" font-weight="700" fill="#0f172a">nul</text>
  <text x="45" y="145" text-anchor="middle" font-size="11.5" fill="#334155">0°</text>
  <line x1="116" y1="95" x2="154" y2="95" stroke="#0f172a" stroke-width="2"/>
  <line x1="116" y1="95" x2="116" y2="57" stroke="#0f172a" stroke-width="2"/>
  <polyline points="128,95 128,83 116,83" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <circle cx="116" cy="95" r="2.6" fill="#0f172a"/>
  <text x="135" y="128" text-anchor="middle" font-size="12.5" font-weight="700" fill="#0f172a">droit</text>
  <text x="135" y="145" text-anchor="middle" font-size="11.5" fill="#334155">90°</text>
  <line x1="206" y1="95" x2="244" y2="95" stroke="#0f172a" stroke-width="2"/>
  <line x1="206" y1="95" x2="168" y2="95" stroke="#0f172a" stroke-width="2"/>
  <path d="M 220 95 A 14 14 0 0 0 192 95" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <circle cx="206" cy="95" r="2.6" fill="#0f172a"/>
  <text x="225" y="128" text-anchor="middle" font-size="12.5" font-weight="700" fill="#0f172a">plat</text>
  <text x="225" y="145" text-anchor="middle" font-size="11.5" fill="#334155">180°</text>
  <line x1="296" y1="95" x2="334" y2="95" stroke="#0f172a" stroke-width="2"/>
  <circle cx="296" cy="95" r="16" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <polyline points="307,90 312,95 307,100" fill="none" stroke="#F97316" stroke-width="1.8" stroke-linecap="round"/>
  <circle cx="296" cy="95" r="2.6" fill="#0f172a"/>
  <text x="315" y="128" text-anchor="middle" font-size="12.5" font-weight="700" fill="#0f172a">plein</text>
  <text x="315" y="145" text-anchor="middle" font-size="11.5" fill="#334155">360°</text>
</svg>`.trim();

// -- Figure Ex. 4 : la longueur des cotes ne fait pas l'angle --
// Le regime piege du generateur donne TOUJOURS les cotes les plus longs au
// plus petit angle. La fiche montre exactement ce cas, sans donner de
// mesure : l'exercice n'en donne pas non plus, il se juge a l'ecartement.
const SVG_ECARTEMENT = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 216" role="img"
     aria-label="Deux angles. Celui de gauche a des cotes longs mais un petit ecartement ; celui de droite a des cotes courts mais un ecartement plus grand.">
  <line x1="80" y1="140" x2="180.0" y2="140.0" stroke="#378ADD" stroke-width="2.4"/>
  <line x1="80" y1="140" x2="156.6" y2="75.7" stroke="#378ADD" stroke-width="2.4"/>
  <path d="M 110 140 A 30 30 0 0 0 103.0 120.7" fill="none" stroke="#F97316" stroke-width="2.2"/>
  <circle cx="80" cy="140" r="3" fill="#0f172a"/>
  <text x="130" y="168" text-anchor="middle" font-size="11.5" font-weight="700" fill="#378ADD">côtés longs</text>
  <line x1="250" y1="140" x2="305.0" y2="140.0" stroke="#E24B4A" stroke-width="2.4"/>
  <line x1="250" y1="140" x2="268.8" y2="88.3" stroke="#E24B4A" stroke-width="2.4"/>
  <path d="M 276 140 A 26 26 0 0 0 258.9 115.6" fill="none" stroke="#F97316" stroke-width="2.2"/>
  <circle cx="250" cy="140" r="3" fill="#0f172a"/>
  <text x="278" y="168" text-anchor="middle" font-size="11.5" font-weight="700" fill="#E24B4A">côtés courts</text>
  <text x="180" y="190" text-anchor="middle" font-size="11.5" font-weight="700" fill="#0f172a">les côtés bleus sont les plus longs, et pourtant</text>
  <text x="180" y="206" text-anchor="middle" font-size="11.5" font-weight="700" fill="#0f172a">c’est l’angle rouge qui est le plus grand</text>
</svg>`.trim();

// -- Figure Ex. 5 : deux angles adjacents qui s'additionnent --
// 33 et 46 : ni l'un ni l'autre n'est dans MESURES_EX5A ou PETITS_EX5B, et
// leur somme 79 n'est atteignable ni comme somme de deux mesures du pool 5a
// ni comme difference M - m1 du pool 5b. La fiche montre les deux sens de
// lecture, l'addition et la soustraction, puisque le format tire les deux.
const SVG_ADDITION = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 200" role="img"
     aria-label="Trois demi-droites Ox, Oy et Oz issues de O. L angle xOy vaut 33 degres, yOz vaut 46 degres, et l angle total xOz vaut 79 degres.">
  <line x1="70" y1="170" x2="200.0" y2="170.0" stroke="#0f172a" stroke-width="2"/>
  <line x1="70" y1="170" x2="179.0" y2="99.2" stroke="#0f172a" stroke-width="2"/>
  <line x1="70" y1="170" x2="94.8" y2="42.4" stroke="#0f172a" stroke-width="2"/>
  <path d="M 98.5 151.5 A 34 34 0 0 0 76.5 136.6" fill="none" stroke="#E24B4A" stroke-width="2.2"/>
  <path d="M 130.0 170.0 A 60 60 0 0 0 120.3 137.3" fill="none" stroke="#378ADD" stroke-width="2.2"/>
  <path d="M 158.0 170.0 A 88 88 0 0 0 86.8 83.6" fill="none" stroke="#0f172a" stroke-width="1.8"/>
  <circle cx="70" cy="170" r="3.2" fill="#0f172a"/>
  <text x="95.7" y="135.9" text-anchor="middle" font-size="12" font-weight="700" fill="#E24B4A">46&#176;</text>
  <text x="139.0" y="153.6" text-anchor="middle" font-size="12" font-weight="700" fill="#378ADD">33&#176;</text>
  <text x="147.2" y="110.4" text-anchor="middle" font-size="12" font-weight="700" fill="#0f172a">79&#176;</text>
  <text x="209.0" y="175.0" text-anchor="start" font-size="13" font-style="italic" fill="#0f172a">x</text>
  <text x="187.0" y="96.2" text-anchor="start" font-size="13" font-style="italic" fill="#0f172a">y</text>
  <text x="85.8" y="37.4" text-anchor="end" font-size="13" font-style="italic" fill="#0f172a">z</text>
  <text x="59" y="187" text-anchor="end" font-size="13" fill="#0f172a">O</text>
  <text x="246" y="106" font-size="12.5" font-weight="700" fill="#0f172a">xÔy + yÔz = xÔz</text>
  <text x="246" y="128" font-size="12.5" font-weight="700" fill="#0f172a">33&#176; + 46&#176; = 79&#176;</text>
  <text x="246" y="158" font-size="11.5" fill="#334155">yÔz = xÔz − xÔy</text>
  <text x="246" y="178" font-size="11.5" fill="#334155">46&#176; = 79&#176; − 33&#176;</text>
</svg>`.trim();

// -- Figure Ex. 6 : comparer à l'angle droit --
// Aucun nombre du pool MESURES_EX6 n'est ecrit sur la fiche : seul 90 y
// figure, et 90 n'est jamais une reponse possible. Les deux angles lateraux
// ne portent pas de mesure, juste leur position par rapport a 90.
const SVG_REPERES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 176" role="img"
     aria-label="Trois angles : un plus ferme que l angle droit donc sous 90 degres, un angle droit a 90 degres, un plus ouvert donc au-dela de 90 degres.">
  <line x1="30" y1="120" x2="92" y2="120" stroke="#0f172a" stroke-width="2"/>
  <line x1="30" y1="120" x2="65.6" y2="69.2" stroke="#0f172a" stroke-width="2"/>
  <path d="M 50.0 120.0 A 20 20 0 0 0 41.5 103.6" fill="none" stroke="#378ADD" stroke-width="2"/>
  <circle cx="30" cy="120" r="2.8" fill="#0f172a"/>
  <text x="60" y="150" text-anchor="middle" font-size="12" font-weight="700" fill="#378ADD">plus fermé</text>
  <text x="60" y="167" text-anchor="middle" font-size="11.5" fill="#334155">moins de 90&#176;</text>
  <line x1="150" y1="120" x2="212" y2="120" stroke="#0f172a" stroke-width="2"/>
  <line x1="150" y1="120" x2="150.0" y2="58.0" stroke="#0f172a" stroke-width="2"/>
  <polyline points="163,120 163,107 150,107" fill="none" stroke="#F97316" stroke-width="2"/>
  <circle cx="150" cy="120" r="2.8" fill="#0f172a"/>
  <text x="180" y="150" text-anchor="middle" font-size="12" font-weight="700" fill="#F97316">angle droit</text>
  <text x="180" y="167" text-anchor="middle" font-size="11.5" fill="#334155">90&#176;</text>
  <line x1="270" y1="120" x2="332" y2="120" stroke="#0f172a" stroke-width="2"/>
  <line x1="270" y1="120" x2="234.4" y2="69.2" stroke="#0f172a" stroke-width="2"/>
  <path d="M 290.0 120.0 A 20 20 0 0 0 258.5 103.6" fill="none" stroke="#E24B4A" stroke-width="2"/>
  <circle cx="270" cy="120" r="2.8" fill="#0f172a"/>
  <text x="270" y="150" text-anchor="middle" font-size="12" font-weight="700" fill="#E24B4A">plus ouvert</text>
  <text x="270" y="167" text-anchor="middle" font-size="11.5" fill="#334155">plus de 90&#176;</text>
</svg>`.trim();

const CP_662 = {
    lecture_rapporteur_qcm: {
        pages: [
            {
                titre: 'La règle',
                lignes: [
                    'Le rapporteur porte **deux graduations** : l\'une part de la droite, l\'autre de la gauche.',
                    'Repère celle qui marque **0 sur le premier côté** de l\'angle : c\'est celle-là qu\'il faut lire sur le second côté.',
                    'Vérification : un angle plus **fermé** qu\'un angle droit se lit entre **0° et 90°**, un angle plus **ouvert** entre **90° et 180°**.',
                ],
            },
            { titre: 'Un exemple', svg: SVG_RAPPORTEUR },
        ],
    },
    // Même geste que l'exo 1, mais l'élève POSE lui-même le rapporteur : ce qui
    // lui manque n'est pas la lecture des deux échelles, c'est le placement de
    // l'outil. La figure est celle de l'exo 1, qui montre déjà le piège 180 - m.
    mesurer_angle_saisie_rapporteur: {
        pages: [
            {
                titre: 'La règle',
                lignes: [
                    'Place le **centre** du rapporteur exactement sur le **sommet** de l\'angle.',
                    'Fais tourner le rapporteur pour que le **0** tombe sur l\'un des deux côtés.',
                    'Lis la graduation sur le **second côté**, en suivant celle qui part de ce 0.',
                ],
            },
            { titre: 'Un exemple', svg: SVG_RAPPORTEUR },
        ],
    },
    mesures_canoniques_qcm: {
        pages: [
            { titre: 'La règle', svg: SVG_CANONIQUES },
        ],
    },
    comparaison_angles_qcm: {
        pages: [
            {
                titre: 'La règle',
                lignes: [
                    'La mesure d\'un angle ne dépend **pas** de la longueur de ses côtés : les prolonger ou les raccourcir ne change rien.',
                    'Ce qui compte, c\'est l\'**écartement** des deux côtés. Pour comparer, imagine que tu poses un angle sur l\'autre, sommet sur sommet et un côté sur un côté.',
                ],
            },
            { titre: 'Un exemple', svg: SVG_ECARTEMENT },
        ],
    },
    composition_angles_adj_saisie: {
        pages: [
            {
                titre: 'La règle',
                lignes: [
                    'Deux angles **adjacents** ont le même sommet et un **côté commun**. Leurs mesures **s\'ajoutent** pour donner l\'angle total.',
                    'Pour retrouver un angle **intérieur**, on fait l\'opération inverse : on **soustrait** l\'autre du total.',
                ],
            },
            { titre: 'Un exemple', svg: SVG_ADDITION },
        ],
    },
    estimation_vue_qcm: {
        pages: [
            {
                titre: 'La règle',
                lignes: [
                    'Pour estimer un angle à vue, **compare-le à l\'angle droit**, qui vaut 90° : plus **fermé**, il mesure moins ; plus **ouvert**, il mesure plus.',
                    'Second repère : l\'angle **plat** vaut 180°. Un angle très ouvert, mais qui ne forme pas une ligne droite, est entre les deux.',
                ],
            },
            { titre: 'Un exemple', svg: SVG_REPERES },
        ],
    },
};

export default CP_662;
